/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import { DEFAULT_PAGE_HEADER_HEIGHT } from 'bundles/composable-page-header/constants';

type Props = {
  children: React.ReactNode;
  fullWidth?: boolean;
};

// We subtract 1px from the default height to account for the border on the bottom of the nav added in GlobalPageHeaderContainer.
// We add a 0.5px white/invisible border to the top of mainNav so we are vertically centered with the border on the bottom of the nav
// (as if the border was added to this element and was using box-sizing: border-box).
const styles = {
  navContainer: css`
    height: ${DEFAULT_PAGE_HEADER_HEIGHT - 1}px;

    > div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  `,
  fullWidthNavContainer: css`
    height: ${DEFAULT_PAGE_HEADER_HEIGHT - 1}px;
    padding-left: var(--cds-spacing-300);
    padding-right: var(--cds-spacing-300);
  `,
  mainNav: css`
    border-top: 0.5px solid var(--cds-color-white-0);
    height: ${DEFAULT_PAGE_HEADER_HEIGHT - 1}px;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  `,
};

// Establishes the height for desktop/mobile main navs. Meant to directly wrap CDS Grid components.
const MainNavigationWrapper = ({ children, fullWidth }: Props) => {
  if (fullWidth) {
    return (
      <div css={[styles.fullWidthNavContainer]} className="main-nav-container">
        <Grid container css={styles.mainNav} wrap="nowrap">
          {children}
        </Grid>
      </div>
    );
  } else {
    return (
      <PageGridContainer css={styles.navContainer} className="main-nav-container">
        <Grid container item xs={12} css={styles.mainNav}>
          {children}
        </Grid>
      </PageGridContainer>
    );
  }
};

export default MainNavigationWrapper;
